import React from 'react';

import styles from './DeliveryPickup.module.css'
import {Order} from "../../../../../../types/Order.interface.ts";
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";

interface Props {
    offer: Order,
}

export const DeliveryPickup: React.FC<Props> = ({offer}) => {
    return (
        <>
            <h3 className={styles.title}>Выбранный пункт самовывоза:</h3>
            <div className={styles.point}>
                {offer.delivery.point.address}
            </div>
            <div className={styles.schedule}>
                {offer.delivery.point.schedule.split(',').map((hours) => {
                    return <div key={hours}>{hours}</div>
                })}
            </div>
            <div>
                {
                    offer.delivery.point.latitude && offer.delivery.point.longitude
                        ? <YMaps>
                            <Map
                                defaultState={{
                                    zoom: 16,
                                    controls: [],
                                    center: [offer.delivery.point.latitude, offer.delivery.point.longitude],
                                }}
                                width="100%"
                                height={485}
                            >
                                <Placemark
                                    modules={["geoObject.addon.balloon"]}
                                    defaultGeometry={[offer.delivery.point.latitude, offer.delivery.point.longitude]}
                                />
                            </Map>
                        </YMaps>
                        : null
                }
            </div>
        </>
    );
};